import {svgIconWrapper} from '../svg-icon-wrapper';

import GoogleCalendarRegular from './google-calendar-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <GoogleCalendarRegular {...props} />;
}

SvgComponent.iconName = 'googleCalendarRegular';

export const GoogleCalendarRegularIcon = svgIconWrapper(SvgComponent);
